import { useCallback } from "react";
import { useSetAtom } from "jotai";
import { useAtomCallback } from "jotai/utils";
import { Button } from "@zapier/design-system";
import { clearCanvasSetter } from "@zapier/canvas-state";
import { useCenterAndZoomOnNode } from "../../hooks/useCenterAndZoomOnNode";

const ClearCanvasButton = () => {
  const clearCanvas = useSetAtom(clearCanvasSetter);
  const { centerAndZoomOnNode } = useCenterAndZoomOnNode();

  const onClick = useAtomCallback(
    useCallback(async () => {
      await clearCanvas(centerAndZoomOnNode);
    }, [clearCanvas, centerAndZoomOnNode]),
  );

  return (
    <Button color="primary" size="small" onClick={onClick}>
      Clear (⌘⇧C)
    </Button>
  );
};

export default ClearCanvasButton;
